import React from 'react'
import { InputStld } from './InputStyled'
import helperhandleBlur from './helpers/handleBlur'
import helperhandleChange from './helpers/handleChange'
import { InputProps } from './interface'
import { regexes } from './regex'

export default function Input({
  number,
  setnumber,
  setinputStake,
  toFix,
  min,
  max,
  maxLength,
  type,
  width,
  height,
  textcenter,
  size,
  margin,
  handleNotification,
  currency,
  textOverflow,
  overflow,
  datatestid,
  isZero,
  innerBackground,
  borderColor,
  active,
  radius,
  pattern,
  inputMode,
  focusColor,
  padding,
}: InputProps) {
  const regex = regexes[type]

  const handleChange = (e: any) =>
    helperhandleChange(e, regex, toFix, setinputStake, setnumber)

  const handleBlur = (e: any) =>
    helperhandleBlur(
      e,
      setinputStake,
      min,
      max,
      toFix,
      setnumber,
      handleNotification,
      currency,
      type,
      isZero,
    )

  return (
    <InputStld
      type={type}
      pattern={pattern}
      inputMode={inputMode}
      maxLength={maxLength}
      value={number}
      onChange={handleChange}
      onBlur={handleBlur}
      width={width}
      height={height}
      fontsize={size}
      textcenter={textcenter}
      margin={margin}
      textOverflow={textOverflow}
      overflow={overflow}
      data-testid={datatestid}
      innerBackground={innerBackground}
      active={active}
      borderColor={borderColor}
      radius={radius}
      focusColor={focusColor}
      padding={padding}
    />
  )
}

// const n = e.target.value

// if (checkForEmpty(n)) {
//   return setinputStake((+min).toFixed(toFix)) && setnumber(min)
// }
// if (checkOnlyDot(n)) {
//   return setinputStake((+min).toFixed(toFix)) && setnumber(min)
// }

// const wz: string = checkStartWithZeros(n)
// let m = checkMaxMin(wz, max, min, handleNotification, currency, toFix)
// if (type === 'numbersAndDot' || type === 'onlyNumbers') {
//   m = (+m).toFixed(toFix)
// }
// setinputStake(m)
// setnumber(m)

// const handleChange = (e: any) => {
//   const n = e.target.value
//   if (checkRegEx(n, regex)) {
//     if (checkForLengthAfterDot(n, toFix)) {
//       setinputStake(n)
//       setnumber(n)
//     }
//   }
// }
